<template>
<div>
    <Header ref="header" />
    <router-view></router-view>
    <Footer />
    <SocketConnect />
</div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import { loginByTokenApi, getClientIdApi, getVersionApi, thirdLoginApi, setOrgApi  } from '@/api/login.js'
import { getExpiresTime, base64ToHex } from '@/util/public.js'
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"
import Announce from "@/components/Announce.vue"
import Black from "@/components/BlackDialog.vue"
import SocketConnect from "@/components/SocketConnect.vue"
import { isHttps } from '@/util/const.js'
import { Base64 } from "js-base64";
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Announce,
    SocketConnect,
    Black
  },
  data(){
    return{
      versionType: 'home',
      isBlackUser: false
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods:{
    ...mapMutations(['setState', 'setSocketConnectOnOutline']),
    //若已存储cookie，调用接口
    async loginByToken(){
      let data = await loginByTokenApi({platform:2})
      this.setState({ key: "hideRight", value: false });
      if (!data || !data.success || data.content.isOrg) {
       this.setSocketConnectOnOutline(false);
       this.setState({ key: 'isLogged', value: false });
       this.setState({ key: "userInfo", value: null });
       this.$cookie.set("LID", '', { domain: '.agriknow.cn', expires: -1 });
       this.$cookie.set("AID", '', { domain: '.agriknow.cn', expires: -1 });
       this.$cookie.set("LID", '', { domain: 'ai.agriknow.cn', expires: -1 });
       this.$cookie.set("AID", '', { domain: 'ai.agriknow.cn', expires: -1 });
       this.getReturnUrl()
       return;
      };
      if(data.content.isEnable == false){
        this.isBlackUser = true
      }
        let link = window.location.href;
        let str = link.split('?')[1] || '';
        let arr = str.split('&');
        let para = {};
        arr.forEach(function(v,k){
            var ar = v.split('=');
            para[ar[0]] = decodeURIComponent(ar[1] || '');
        });
        data.content.realName = para.realName;
        this.$bus.$emit("sedGetOrgPow", data.content.userName);
      this.setState({ key: "userInfo", value: data.content });
      this.setState({ key: 'isLogged', value: true });
      this.setSocketConnectOnOutline(true);
      this.setOrg()
    },
    //是否需要跳转到对应url
    getReturnUrl(){
       let search = window.location.search
       if(!search) return;
       let query = search.substring(1)
       let queryItem = query.split("=")
       if(queryItem[0] != 'returnUrl') return;
       this.$nextTick(() =>{
          this.$refs['header'].loginOrRegister('1', queryItem[1])
       })
    },
    async getClientId(){
      let data = await getClientIdApi()
      if (!data || !data.success) return
      let expiresTime = getExpiresTime(1)
      document.cookie=`Ecp_ClientId=${data.content };expires=${expiresTime};domain=.agriknow.cn;path=/;`;
      document.cookie=`Ecp_ClientId=${data.content };expires=${expiresTime};domain= ai.agriknow.cn;path=/;`;
    },
    async thirdLogin(){
      let res = await thirdLoginApi({ thirdToken: window.location.href.split('thirdToken=')[1] })
      if (!res.success) return;
      let expiresTime = getExpiresTime(1)
      document.cookie = `AID=${res.content};expires=${expiresTime}; domain=.agriknow.cn;path=/;`;
      document.cookie = `LID=${res.content};expires=${expiresTime}; domain=.agriknow.cn;path=/;`;
      document.cookie = `AID=${res.content};expires=${expiresTime}; domain=ai.agriknow.cn;path=/;`;
      document.cookie = `LID=${res.content};expires=${expiresTime}; domain=ai.agriknow.cn;path=/;`;
    },
    async getVersion(){
      let data = await getVersionApi({
         _t: new Date().getTime()
      })
      if(data && data.version){
        let vueVersion = data.version;
        let localVueVersion = localStorage.getItem('vueVersion_' + this.versionType);
        if (localVueVersion && localVueVersion != vueVersion) {
          localStorage.setItem('vueVersion_' +this.versionType, vueVersion);
          window.location.reload();
          return;
        } else {
          localStorage.setItem('vueVersion_' + this.versionType, vueVersion);
        }
      }
    },
    //登录成功后调取接口
    async setOrg(){
      let params = {
        userName: base64ToHex(this.userInfo.userName),
        userId: this.userInfo.userId,
        orgId: isHttps?'3703':'1553',
        realName: base64ToHex(this.userInfo.realName),
        phone: base64ToHex(this.userInfo.phone)
      }
      await setOrgApi(params)
    },
  },
  async created(){
    await this.getVersion()
    if (window.location.href.includes('thirdToken=')) {
      await this.thirdLogin()
    }
    this.getClientId()
    //是否已存储cookie
    let cookieAry = document.cookie.split(';');
    for (let i = 0; i <= cookieAry.length - 1; i++) {
      if (cookieAry[i].split('=')[0].includes('LID') || cookieAry[i].split('=')[0].includes('ASPID')) {
        let lid = cookieAry[i].split('=').splice(1).join('=');
        if (lid) {
          this.loginByToken();
        } else {
          this.setState({ key: "userInfo", value: null });
          this.setState({ key: "isLogged", value: false });
          this.setState({ key: "hideRight", value: false });
          this.getReturnUrl();
        }
      }else{
        this.getReturnUrl();
        this.setState({ key: "hideRight", value: false });
      }
   }
  }
}
</script>

